//***************** Interfaces *****************//

export interface IServiceByProviderListItemBackEndModel {
  id: string;
  serviceProductType: number;
  countries: string;
}

export interface IServiceByProviderListItemFrontEndModel {
  id: string;
  serviceProductType: string;
  countries: string;
}

export interface DetailConfig {
  type: number;
  name: string;
  isRequired: boolean;
}

export interface IManageServiceFormModel {
  id: string;
  serviceProviderId?: string;
  serviceType: {
    id: number;
    name: string;
  };
  countries: {
    code: string;
    name: string;
    group: string;
  }[];
  details: Record<string, string>;
  detailFiles: {
    id: string;
    name: string;
    size: number;
    preview: string;
  }[];
}

export interface IDetailsViewModel {
  content: string;
  type: number;
  name: string;
}

export interface IDetailFileFrontEndModel {
  id: string;
  name: string;
  size: number;
  path: string;
}

export interface IDetailFileBackEndModel {
  name: string;
  size: number;
  path: string;
}

export interface IViewServiceModel {
  serviceTypeName: string;
  countries: string;
  details: IDetailsViewModel[];
  detailFiles: IDetailFileFrontEndModel[];
}

export interface IViewMoreServiceFrontEndModel {
  id: string;
  serviceTypeName: string;
  countries: string[];
  serviceProvider: {
    id: string;
    name: string;
    image: string;
    country: string;
  };
  details: IDetailsViewModel[];
  extraDocuments: {
    name: string;
    size: number;
    path: string;
  }[];
}

export interface IViewMoreServiceBackEndModel {
  id: string;
  serviceProductType: number;
  countries: string[];
  serviceProvider: {
    id: string;
    name: string;
    country: string;
    image: {
      preview: string;
    };
  };
  details: IDetailsViewModel[];
  detailFiles: IDetailFileBackEndModel[];
}

export interface IViewMoreContactsBackEndModel {
  phone: string;
  email: string;
  website: string;
}

export interface IGetServiceBackEndModel {
  id: string;
  serviceProductType: number;
  countries: string[];
  details: {
    type: number;
    content: string;
  }[];
  detailFiles: {
    fileId: string;
    path: string;
    size: number;
    name: string;
  }[];
}

export interface IGetViewServiceBackEndModel {
  id: string;
  serviceProductType: number;
  countries: string;
  details: {
    type: number;
    content: string;
  }[];
  detailFiles: {
    fileId: string;
    path: string;
    size: number;
    name: string;
  }[];
}

export interface IServiceBackEndModel {
  id: string;
  serviceProviderId?: string;
  serviceProductType: number;
  countries: string[];
  details: {
    type: number;
    content: string;
  }[];
  detailFiles: {
    fileId: string;
  }[];
}

//***************** Enums *****************//
export enum ServiceType {
  Insurance = 1,
  SimCard = 2,
  EssayReview = 3,
  Guardianship = 4,
  Accommodation = 5,
  LawyerConsultation = 6,
  VisaSupport = 7,
  OnlineCourses = 8,
  Library = 9,
  TravelAssistance = 10,
  Internship = 11,
  Volunteering = 12,
  WorkAndTravel = 13,
  FindJob = 14,
  Ranking = 15,
  StudentLoan = 16,
  MoneyTransfer = 17,
  PickUpDropOff = 18,
  BankCard = 19,
  LanguageCourses = 20,
  ShortProfessionalCourses = 21,
  SummerSchools = 22,
  StudentToStudentCommunication = 23,
  ImmigrationPrograms = 24,
  SupportService = 25,
}

export enum ServiceDetailType {
  ServiceDetails = 1,
  OperatingCountries = 2,
  CostsAndPackages = 3,
  PaymentPlanOptions = 4,
  CancellationPolicyAndRefunds = 5,
  OtherComments = 6,
  Upgrades = 7,
  FAQ = 8,
}

export interface IServiceByProvider {
  id: string;
  countries: string;
  providerImagePath: string;
  providerName: string;
};
